import { useCommonStore } from '../../store/store';
import { exportCsv } from '../components/common/exportCsv';
import { useFloatingActionBar } from './floatingActionBar';

export const useAgentTableDownload = ({ state, setState, selectedView }) => {
    const timeIntervals = useCommonStore(s => s.timeIntervals);

    const handleDownload = (selectedAgents) => {
        exportCsv(
            {
                ...state,
                listingProfColumns: state.listingProficiencyColumns,
                timeIntervals,
            },
            setState,
            selectedView,
            selectedAgents,
            selectedView
        );
    };

    return useFloatingActionBar(undefined, handleDownload);
};
